// extracted by mini-css-extract-plugin
export default {"sbjectsGradesCategories":"course_sbjectsGradesCategories__AziI5"};